// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import PoiName from './PoiName';
import PoiLocation from './PoiLocation';
import MText from '../../../../../components/Common/MText';
import Colours from '../../../../../styles/colours';
import PoiButton from '../PoiButton';
import { IsEmpty } from '../../../../../common/checks';
import TagsOthers from './TagsOthers';

const PoiSubStage = {
  Name:     'Name',
  Location: 'Location',
  Others:   'Others',
};

const PoiStage = (props) => {
  const {
    poiData, onUpdatePoiData, onCompleteForm, currentSubStage, onSubStageChange,
  } = props;

  const isNextButtonDisabled = currentSubStage === PoiSubStage.Location
    ? IsEmpty(poiData.address)
    : currentSubStage === PoiSubStage.Others && IsEmpty(poiData.tags);

  return (
    <div className="mt-3">
      {
        currentSubStage !== PoiSubStage.Name && (
          <MText
            style={{ fontWeight: 400, alignSelf: 'start' }}
            size={13}
            colour={Colours.Gray}
            className="mt-2"
          >
            You are uploading a new place:
            {' '}
            <span className="font-weight-bold" style={{ color: Colours.Black }}>
              {poiData.proposedName}
            </span>
          </MText>
        )
      }
      <div
        className="w-100 mx-auto"
      >
        {
          currentSubStage === PoiSubStage.Name && (
            <PoiName
              searchKeyword={poiData.proposedName}
              selectedPoi={poiData.selectedPoi}
              onSearchKeywordChange={(val) => onUpdatePoiData('proposedName', val)}
              onSelectedPoiChange={(poi) => onUpdatePoiData('selectedPoi', poi)}
              onProceedWithNewPoi={() => onSubStageChange(PoiSubStage.Location)}
              onProceedWithExistingPoi={() => onCompleteForm()}
            />
          )
        }
        {
          currentSubStage === PoiSubStage.Location && (
            <div className="w-100 mt-4">
              <PoiLocation
                address={poiData.address}
                isCustomAddress={poiData.isCustomAddress}
                onAddressChange={(val) => onUpdatePoiData('address', val)}
                onIsCustomAddressChange={(val) => onUpdatePoiData('isCustomAddress', val)}
              />
            </div>

          )
        }
        {
          currentSubStage === PoiSubStage.Others && (
            <div className="w-100 mt-4 pt-2">
              <TagsOthers
                data={{
                  tags:        poiData.tags,
                  description: poiData.description,
                  hours:       poiData.hours,
                }}
                onUpdatePoiData={onUpdatePoiData}
                disabled={false}
              />
            </div>
          )
        }
        {
          currentSubStage !== PoiSubStage.Name && (
            <div className="d-flex justify-content-between align-items-center w-100 mt-5">
              <PoiButton
                textSize={13}
                text="Back"
                onClick={() => {
                  props.onScrollToTop();
                  if (currentSubStage === PoiSubStage.Others) {
                    onSubStageChange(PoiSubStage.Location);
                  } else if (currentSubStage === PoiSubStage.Location) {
                    onSubStageChange(PoiSubStage.Name);
                  }
                }}
              />
              <PoiButton
                textSize={13}
                text={currentSubStage === PoiSubStage.Location ? 'Next' : 'Next, photos upload'}
                disabled={isNextButtonDisabled}
                onClick={() => {
                  props.onScrollToTop();
                  if (currentSubStage === PoiSubStage.Location) {
                    onSubStageChange(PoiSubStage.Others);
                  } else if (currentSubStage === PoiSubStage.Others) {
                    onCompleteForm();
                  }
                }}
              />
            </div>
          )
        }
      </div>
    </div>
  );
};

PoiStage.defaultProps = {
  onScrollToTop: () => {},
};

PoiStage.propTypes = {
  poiData: PropTypes.shape({
    proposedName:    PropTypes.string,
    selectedPoi:     PropTypes.shape({}),
    address:         PropTypes.string,
    isCustomAddress: PropTypes.bool,
    tags:            PropTypes.arrayOf(PropTypes.string),
    description:     PropTypes.string,
    hours:           PropTypes.string,
  }).isRequired,
  onUpdatePoiData:  PropTypes.func.isRequired,
  onCompleteForm:   PropTypes.func.isRequired,
  currentSubStage:  PropTypes.string.isRequired,
  onSubStageChange: PropTypes.func.isRequired,
  onScrollToTop:    PropTypes.func,
};

export default PoiStage;
